import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { IIconProperty } from 'types/iconProps';

const MetamaskIcon = ({ width, height, color }: IIconProperty) => {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox="0 0 25 24"
      style={{ transform: 'scale(1)', width, height }}
    >
      <path
        d="M23.5429 0.727051L14.1572 7.79614L15.9072 3.62887L23.5429 0.727051Z"
        fill="#E17726"
        stroke="#E17726"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.90008 0.727051L11.2001 7.85432L9.5358 3.63614L1.90008 0.727051ZM20.1644 17.1125L17.6644 20.9961L23.0144 22.4943L24.5429 17.1998L20.1644 17.1125ZM0.907227 17.1998L2.42866 22.4943L7.76437 20.9961L5.27866 17.1125L0.907227 17.1998Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47839 10.5525L5.99268 12.8362L11.2784 13.0834L11.107 7.28708L7.47839 10.5598V10.5525ZM17.9641 10.5598L14.2784 7.21436L14.157 13.0834L19.4427 12.8362L17.9641 10.5598ZM7.7641 20.9962L10.9712 19.4253L8.2141 17.2434L7.7641 20.9962ZM14.4784 19.418L17.6641 20.9962L17.2355 17.2362L14.4784 19.418Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6642 20.9962L14.4784 19.4253L14.7356 21.5344L14.707 22.4289L17.6642 20.9962ZM7.76416 20.9962L10.7356 22.4289L10.7142 21.5344L10.9713 19.4253L7.76416 20.9962Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7859 15.8398L8.14307 15.0543L10.0145 14.1816L10.7931 15.8398H10.7859ZM14.6502 15.8398L15.4359 14.1743L17.3145 15.047L14.6502 15.847V15.8398Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.76452 20.9964L8.22881 17.1128L5.27881 17.2001L7.76452 20.9964ZM17.2145 17.1128L17.6645 20.9964L20.1645 17.2001L17.2145 17.1128ZM19.4502 12.8364L14.1645 13.0837L14.6502 15.8473L15.436 14.1746L17.3145 15.0473L19.4502 12.8364ZM8.14309 15.0546L10.0145 14.1819L10.7931 15.8401L11.286 13.0764L6.00024 12.8364L8.14309 15.0546Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12.8364L8.21429 17.2364L8.14286 15.0546L6 12.8364ZM17.3143 15.0546L17.2286 17.2364L19.4429 12.8364L17.3143 15.0546ZM11.2857 13.0837L10.7857 15.8473L11.4143 19.1055L11.5571 14.8073L11.2857 13.0837ZM14.1571 13.0837L13.9 14.8001L14.0286 19.1055L14.65 15.8401L14.1571 13.0764V13.0837Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.65 15.8401L14.0286 19.1056L14.4786 19.4256L17.2286 17.2438L17.3143 15.0547L14.65 15.8401ZM8.14288 15.0547L8.21431 17.2365L10.9715 19.4183L11.4143 19.1056L10.7929 15.8401L8.13574 15.0547H8.14288Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7142 22.4293L14.7356 21.5348L14.4927 21.3311H10.9499L10.7142 21.5348L10.7356 22.4293L7.76416 20.9966L8.80702 21.8693L10.9142 23.3457H14.5213L16.6356 21.862L17.6642 20.9966L14.707 22.4293H14.7142Z"
        fill="#C0AC9D"
        stroke="#C0AC9D"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4786 19.4182L14.0286 19.1055H11.4144L10.9715 19.4255L10.7144 21.5346L10.9501 21.3309H14.4929L14.7358 21.5346L14.4786 19.4255V19.4182Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9429 8.25432L24.7286 4.36341L23.5429 0.727051L14.4715 7.56341L17.9644 10.5525L22.8929 12.0143L23.9786 10.727L23.5072 10.378L24.2572 9.67978L23.6858 9.22887L24.4358 8.64705L23.9358 8.25432H23.9429ZM0.714355 4.35614L1.51436 8.25432L1.00007 8.63978L1.76436 9.2216L1.19293 9.67978L1.93578 10.378L1.46436 10.727L2.55007 12.0143L7.47864 10.5598L10.9715 7.55614L1.90007 0.727051L0.714355 4.35614Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8929 12.0144L17.9644 10.5598L19.4501 12.8362L17.2358 17.2362L20.1644 17.1998H24.5429L22.8929 12.0144ZM7.47866 10.5525L2.55008 12.0144L0.907227 17.1998H5.2858L8.21437 17.2362L6.00008 12.8362L7.4858 10.5525H7.47866ZM14.1572 13.0835L14.4787 7.55618L15.9072 3.62891H9.5358L10.9644 7.55618L11.2858 13.0835L11.4072 14.8144V19.1053H14.0287L14.0429 14.8144L14.1572 13.0835Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default MetamaskIcon;
